import posthog from 'posthog-js'

export function initPostHog() {
  const apiKey = document.body.dataset.posthogKey
  if (!apiKey) return

  posthog.init(apiKey, {
    api_host: 'https://eu.i.posthog.com',
    persistence: 'memory',
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: true,
    respect_dnt: true,
  })

  document.addEventListener('turbo:load', () => {
    posthog.capture('$pageview')
  })
}
